import React           from 'react';
import colors          from '../../utils/colors'
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        width:          150,
        height:         150,
        position:       'fixed',
        top:            20,
        left:           15,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'space-evenly',
        flexFlow:       'column',
    },
    button: {
        height:          40,
        width:           150,
        fontSize:        18,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: colors.blue,
        color:           '#FFF'
    }
}))

type NavButtonProps = {
    level:               number;
    lastTest:            boolean;
    showUndoButton:      boolean;
    unDo:                () => void;
    handleGoToNextTest:  () => void;
    handleGoToNextLevel: () => void;
}

const NavButton: React.FC<NavButtonProps> = ({ 
    level, 
    lastTest, 
    showUndoButton, 
    unDo, 
    handleGoToNextTest, 
    handleGoToNextLevel 
}) => {

  const classes = useStyles();

  return (
    <div className = { classes.root }>
        {/* <div 
            className = { classes.button }
            onClick   = { handleGoToNextLevel }
            dir       = { 'rtl' }
            style     = {{
                opacity: level === 2 ? 0 : 1,
                cursor:  level === 2 ? 'default' : 'pointer'
            }}
        >
            { `לשלב הבא` }
        </div> */}
        <div 
            className = { classes.button }
            onClick   = { () => { if (!lastTest) { handleGoToNextTest() }}}
            dir       = { 'rtl' }
            style     = {{
                opacity: lastTest ? 0 : 1,
                cursor:  lastTest ? 'default' : 'pointer'
            }}
        >
            { `לתרגיל הבא` }
        </div>
        <div 
            className = { classes.button }
            onClick   = { () => { if (showUndoButton) { unDo() }}}
            dir       = { 'rtl' }
            style     = {{
                opacity: !showUndoButton ? 0.3 : 1,
                cursor:  !showUndoButton ? 'default' : 'pointer'
            }}
        >
            { `איפוס` }
        </div>
    </div>
  );
}



export default NavButton;








